import { QuestionContextService } from '../../../data/services'
import { QuestionContext } from '../../../data/models'
import { IDataServiceConfig, ModelRepository } from '../../../model-repository'
import { QuestionContextPresenter } from '../../../data/presenters'
import { IEntityMappingConfig } from '../../..'

export const QuestionContextConfig: IDataServiceConfig<QuestionContext> = {
  service: QuestionContextService,
  deps: [ModelRepository],
  endpoint: 'exams/question_contexts',
  model: QuestionContext,
  presenter: QuestionContextPresenter,
  backend: 'uncached',
  mappings: [
    {
      classType: 'QuestionContext',
      jsonType: 'question-contexts',
      propertyMapping: {
        options: {
          isCollection: false,
          transform: {
            toModel: (data) => JSON.parse(data || '[]'),
            toJson: (data) => JSON.stringify(data || [])
          }
        }
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/data/question-context.config.ts